import {isNil} from 'ramda';

import {Money} from '@dms/api/shared';

import {normalizeDecimalValue} from './normalizeDecimalValue';

export function normalizeMoneyValue(value: Money | null) {
  if (isNil(value)) {
    return null;
  }

  return {
    ...value,
    amount: normalizeDecimalValue(value.amount) ?? value.amount,
  };
}
